import axios_instance from '../utilities/axios_instance';
import { validateStats } from '../components/crop-intelligence/contract';

const CCStatsService = {
  async getCCStatsForRegion(regionKey, dataset, country, signal) {
    const response = await axios_instance.get('ccstats/v2', {
      params: { country_code: country, year: dataset.year, region_key: regionKey },
      signal, timeout: 60000,
    });
    return validateStats(response.data.data, dataset, country, regionKey);
  },
};

export default CCStatsService;
